import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/nuweraeliya.webp',
  './images/N1.webp',
  './images/N2.webp',
  './images/N3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Nuwara Eliya, known as "Little England," is a charming hill station in Sri Lanka famous for its cool climate and scenic beauty.

Key highlights include:

• Hakgala Botanical Gardens – A beautiful garden with a vast collection of tropical and sub-tropical plants, perfect for peaceful strolls.
• Victoria Park – A well-maintained park in the heart of the town, ideal for picnics and bird watching.
• Addison Bungalow – A historic colonial bungalow surrounded by tea plantations offering a glimpse into the past.
• Lover’s Leap Waterfall – A stunning waterfall with picturesque views and a popular spot for nature lovers.
• Gregory Lake – A serene lake with boating facilities and walking paths.
• Tea Plantations – Rolling green hills covered with lush tea estates; guided tours are available.
• Highlands Tea Factory – Experience tea production firsthand with guided tours at this working tea factory.
• Horton Plains National Park – Famous for its breathtaking landscapes, hiking trails, and the dramatic World's End cliff.
• Local Markets – Offering fresh vegetables, fruits, and unique hill-country produce.
• Authentic Local Foods – Try fresh strawberry products, hill-grown vegetables, and traditional Sri Lankan dishes like Pittu and Lamprais.

Nuwara Eliya is a perfect getaway for nature lovers, history buffs, and those seeking cool mountain air.`,

    zh: `努瓦拉埃利耶，被称为“小英格兰”，是斯里兰卡著名的高山小镇，以凉爽的气候和秀丽的风景闻名。

主要亮点包括：

• 哈格拉植物园 – 拥有丰富的热带和亚热带植物，是散步放松的好去处。
• 维多利亚公园 – 镇中心的优美公园，适合野餐和观鸟。
• 艾迪生乡村别墅 – 被茶园环绕的历史殖民别墅，展现过去的风貌。
• 爱人瀑布 – 风景如画的瀑布，是自然爱好者的热门景点。
• 格雷戈里湖 – 宁静的湖泊，提供划船和步行小径。
• 茶园 – 茂密的茶园覆盖起伏的群山，可参加导览游。
• 高地茶厂 – 参观正在运营的茶厂，亲身体验制茶过程。
• 霍顿平原国家公园 – 以壮丽的风景、徒步小径和著名的“世界尽头”悬崖著称。
• 本地市场 – 新鲜蔬菜、水果和独特的高地农产品。
• 地道美食 – 尝试新鲜草莓制品、高山蔬菜和传统斯里兰卡菜肴如皮图和蓝普瑞斯。

努瓦拉埃利耶是自然爱好者、历史爱好者和寻求凉爽山间空气人士的理想度假胜地。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/nuweraeliya.webp" className="travel-image2" />
          <img src="./images/N1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Nuwara Eliya</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Nuwara Eliya</h2>
          <p className="carousel-subheading">Cool climate, colonial charm, and stunning landscapes</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
